export default "__VITE_ASSET__eE3KeSRI__"